export default __webpack_public_path__ + "static/media/Group_7442.19b00493.png";